<div class="flex flex-col gap-[16px]">
  <app-internal-hydraulic-related-parameters></app-internal-hydraulic-related-parameters>
  <app-internal-hydraulic-volume-flow-explanation
    [installationId]="installationId"
    [gatewaySerial]="gatewaySerial"
  ></app-internal-hydraulic-volume-flow-explanation>
  <app-internal-hydraulic-permanent-inspection-teaser
    *ngIf="!(installationDetailsStore.isProPackageOrRsa$ | async)"
  ></app-internal-hydraulic-permanent-inspection-teaser>
</div>
